import { API_URL } from '../Config.js';

const apiUrl = API_URL 


const getLeyendaImgList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetGrillaImgLeyendas`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const addLeyendaImg = (data, accessToken) => {

    const url = `${apiUrl}formularios/FrmInsertLeyendasImgOC`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}

const frmUpdateLeyendasImgOc = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmUpdateLeyendasImgOc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });
}

const frmDelLeyendasImgOc = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmDelLeyendasImgOc` 

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { 
            return;
        })
        .catch(
            error => { 
                
            }); 

}

const getLeyendaPosicionList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetLeyendasPosicion`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const addLeyendaFirma = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmInsertLeyendasFirmasOc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        .catch(error => { });

}


export { getLeyendaImgList, getLeyendaPosicionList, addLeyendaImg, addLeyendaFirma, frmUpdateLeyendasImgOc, frmDelLeyendasImgOc }